function showOrderStatus(order_data) {
    var $ = jQuery.noConflict();
    // $('#tt-map canvas.mapboxgl-canvas').addClass('asdgasdg');
    // console.log('order_data', order_data);
    $("[data-order-number]").text(order_data.oloid);

    if (order_data.deliverymode === 'drivethru' || order_data.deliverymode === 'pickup') {
        $('[data-order-type-name]').text('Pick Up');
    } else if (order_data.deliverymode === 'dispatch') {
        $('[data-order-type-name]').text('Delivery');
        // $('span[order-status-order-received]').text(`Order in progress`);
        // $('span[order-status-order-in-progress]').text(`Order made`);
        // $('span[order-status-order-ready]').text(`Order delivered`);

    } else if (order_data.deliverymode === 'curbside') {
        $('[data-order-type-name]').text('Curbside Pickup');

    } else {
        $('[data-order-type-name]').text(order_data.deliverymode);
    }
    // Parse the date and time from the readytime string
    var currentTime = new Date();
    // console.log(currentTime, 'order_data.readytime', order_data.readytime);
    var timeOrderReady = new Date(order_data.readytime.substring(0, 4) + '-' +
        order_data.readytime.substring(4, 6) + '-' +
        order_data.readytime.substring(6, 8) + 'T' +
        order_data.readytime.substring(9, 14));

    // Add one hour to the order ready time
    var oneHourLater = new Date(timeOrderReady);
    oneHourLater.setHours(oneHourLater.getHours() + 1);

    // Check if the current time is one hour past the ready time
    // console.log(currentTime.getTime(), oneHourLater.getTime())
    var raw = order_data.readytime; // "20260401 12:03"

    // Split into date + time
    var parts = raw.split(' ');
    var datePart = parts[0]; // "20260401"
    var timePart = parts[1]; // "12:03"

    // Extract pieces
    var year = datePart.substring(0, 4);
    var month = datePart.substring(4, 6) - 1; // JS months are 0-based
    var day = datePart.substring(6, 8);

    var hours = timePart.split(':')[0];
    var minutes = timePart.split(':')[1];

    // Create proper Date
    var readyTime = new Date(year, month, day, hours, minutes);
    console.log('readyTime', readyTime, oneHourLater);
    if (currentTime >= oneHourLater) {
        console.log('Order is 1 hour past ready');
        localStorage.setItem('orderPlacedMoreThanAnHourAgo', 'true');
    } else {
        localStorage.setItem('orderPlacedMoreThanAnHourAgo', 'false');
    }

    // Function to format the time into a 12-hour format (AM/PM)
    function formatAMPM(date) {
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        return hours + ':' + minutes + ' ' + ampm;
    }

    // Function to format the date in MM/DD/YYYY format
    function formatDate(date) {
        var month = date.getMonth() + 1; // Months are zero-based
        var day = date.getDate();
        var year = date.getFullYear();
        return month + '/' + (day < 10 ? '0' + day : day) + '/' + year;
    }

    // Check if the order ready time is today
    function isToday(date) {
        return date.getDate() === currentTime.getDate() &&
            date.getMonth() === currentTime.getMonth() &&
            date.getFullYear() === currentTime.getFullYear();
    }

    // Format the time
    var formatted_time = formatAMPM(timeOrderReady);

    // If the order is not for today, include the date
    if (!isToday(timeOrderReady)) {
        var formatted_date = formatDate(timeOrderReady);
        formatted_time = 'on ' + formatted_date + ' at ' + formatted_time;
    }


    // Format the time
    var formatted_time = formatAMPM(timeOrderReady);
    // If the order is not for today, include the date
    if (!isToday(timeOrderReady)) {
        var formatted_date = formatDate(timeOrderReady);
        formatted_time = formatted_date + ' at ' + formatted_time;
    }

    if ((localStorage.getItem('ecw_customer_order') && ($('body').hasClass('home')) || $('.wf-ordering').length)) {

        // Set the formatted time (and date if applicable) in the element
        $('[data-order-readytime]').text(formatted_time);

        //
        var progress = 0;
        var step = 0;

        var statusSwitch = order_data.status;

        if (order_data.deliverystatus) {
            statusSwitch = order_data.deliverystatus.deliveries[0].status;
        }
        $("[data-order-status]").text(statusSwitch);

        //order data status switch
        console.log('statusSwitch', statusSwitch);
        switch (statusSwitch) {
            case "New":
            case "Accepted":
            case "Transmitting":
            case "Scheduled": // Order Status Enum, Delivery Status Enum
            case "Pending Manual Fire": // Order Status Enum
            case "Pending": // Delivery Status Enum
                progress = 33.3;
                step = 1;
                break;
            case "Preparing":
            case "PickupInProgress": // Delivery Status Enum
                progress = 66.6;
                step = 2;
                break;
            case "Ready":
            case "In Progress": // Order Status Enum
                progress = 66.6;
                step = 2;
                break;
            case "DeliveryInProgress": // Delivery Status Enum
            case "Completed": // Order Status Enum, Delivery Status Enum
                progress = 100;
                step = 3;
                break;
            case "Delivered":
                step = 4;
            case "Canceled": // Order Status Enum, Delivery Status Enum
            case "Rejected":
                progress = 100;
                step = 5;
                break;
            default:
                progress = 0;
                step = 0;
        }

        // Hide ready time if irrelivant
        if (["Delivered", "Completed", "Canceled", "Rejected"].includes(statusSwitch)) {
            $('.order-status-time').addClass('hide');
        } else {
            $('.order-status-time').removeClass('hide');
        }

        stepperItem = '';
        if (order_data.deliverymode === 'dispatch') {
            $('.stepper[delivery]').removeClass('hide');
            $('.stepper[not-delivery]').addClass('hide');
            stepperItem = '.stepper[delivery]';

        } else {
            $('.stepper[delivery]').addClass('hide');
            $('.stepper[not-delivery]').removeClass('hide');
            stepperItem = '.stepper[not-delivery]';

        }
        // console.log('statusSwitch', statusSwitch);

        // step = 3;
        if (step === 1 || step === 0) {
            // console.log('#1');
            $(".order-stepper.order-confirmation .stepper" + stepperItem + " .step-1").addClass("current");
            $('h2[heading-stats-annoucement]').text("order confirmed!");

            if (order_data.deliverymode === 'dispatch') {
                $('h3[subheading-stats-annoucement]').text(`& headed to the kitchen`);
            } else {
                $('h3[subheading-stats-annoucement]').text(`Pickup time: ${formatted_time}`);
            }
        } else if (step === 2) {
            // console.log('stepperItem', $(".order-stepper.order-confirmation .stepper" + stepperItem + " .step-1"));

            $(".order-stepper.order-confirmation .stepper" + stepperItem + " .step-1").addClass("past").removeClass('current');
            $(".order-stepper.order-confirmation .stepper" + stepperItem + " .step-2").addClass("current");

            $(".order-stepper.order-confirmation .stepper" + stepperItem).addClass("one-line");

            if (order_data.deliverymode === 'dispatch') {
                $('h2[heading-stats-annoucement]').text("order Received");
                $('h3[subheading-stats-annoucement]').text(`Delivery time: ${formatted_time}`);
            } else {
                $('h2[heading-stats-annoucement]').text("order in progress");
                $('h3[subheading-stats-annoucement]').text(`Pickup time: ${formatted_time}`);
            }
        }
        else if (step === 3) {
            $(".order-stepper.order-confirmation .stepper" + stepperItem + "  .step-1").addClass("past").removeClass('current');
            $(".order-stepper.order-confirmation .stepper" + stepperItem + " .step-2").addClass("past").removeClass('current');
            $(".order-stepper.order-confirmation .stepper" + stepperItem).addClass("one-line").addClass('two-line');

            if (order_data.deliverymode === 'dispatch') {
                $(".order-stepper.order-confirmation .stepper" + stepperItem + " .step-3").addClass("current");
                $('h2[heading-stats-annoucement]').text("order in route");

                $('h3[subheading-stats-annoucement]').text(`Delivery time: ${formatted_time}`);

            } else {
                $(".order-stepper.order-confirmation .stepper" + stepperItem + " .step-3").addClass("past").removeClass('current');
                $('h2[heading-stats-annoucement]').text("Order is ready!");
                $('h3[subheading-stats-annoucement]').text(`Head over to pickup`);
            }
        }
        else if (step === 4) {
            $(".order-stepper.order-confirmation .stepper" + stepperItem + "  .step-1").addClass("past").removeClass('current');
            $(".order-stepper.order-confirmation .stepper" + stepperItem + "  .step-2").addClass("past").removeClass('current');
            $(".order-stepper.order-confirmation .stepper" + stepperItem + "  .step-3").addClass("past").removeClass('current');
            $(".order-stepper.order-confirmation .stepper" + stepperItem + "  .step-4").addClass("past").removeClass('current');

            $(".order-stepper.order-confirmation .stepper" + stepperItem + " ").addClass("one-line").addClass('two-line');
            $(".order-stepper.order-confirmation .stepper" + stepperItem + "  .delivery").addClass("three-line");

            $('h2[heading-stats-annoucement]').text("order delivered!");
            $('h3[subheading-stats-annoucement]').text(`enjoy every bite`);
        }
        else if (step === 5) {
            $('.order-stepper').parent().addClass('cancelled');
            $('h2[heading-stats-annoucement]').text("order Cancelled");
            $('h3[subheading-stats-annoucement]').text(` `);

            // Add click event to navigate to the order page
            $('.homepage-order-status .button').on('click', function () {
                window.location.href = '/order/';
            });
        }
    }
    console.log('orderPlacedMoreThanAnHourAgo', localStorage.getItem('orderPlacedMoreThanAnHourAgo'));
    if ((localStorage.getItem('orderPlacedMoreThanAnHourAgo') === 'false') && $("#placed-order").length && $(".wf-ordering-start-order").length) {
        console.log('i open');
        $(document).foundation();
        $("#placed-order").foundation("open");

        $('#placed-order [data-close].close').on('click', function () {
            localStorage.setItem('orderPlacedMoreThanAnHourAgo', true);
        });
        $('#placed-order #order-status').on('click', function () {
            change_view('order-complete');
        });
    }
}
jQuery(document).ready(function ($) {
    // console.log('#1');
    const currentPath = window.location.pathname;
    // console.log('currentPath', currentPath);
    if ((localStorage.getItem('orderPlacedMoreThanAnHourAgo') === 'false') &&
        ((localStorage.getItem('ecw_customer_order') && $('body').hasClass('home')) || (localStorage.getItem('ecw_customer_order') && $('.wf-ordering-container').length))) {
        var session_order_data = JSON.parse(localStorage.getItem('ecw_customer_order'));
        var orderguid = session_order_data.id;

        // console.log('olo_get_order');

        $.ajax({
            type: 'POST',
            url: ajax_url,
            data: {
                action: 'olo_get_order',
                orderguid: orderguid,
                referer: window.location.href

            },
            success: function (response) {
                order_data = JSON.parse(response);
                // console.log('asdgasdg', order_data);
                //display order tracker information
                showOrderStatus(order_data);
                if (localStorage.getItem('orderPlacedMoreThanAnHourAgo') === 'false') {
                    $.ajax({
                        type: 'POST',
                        url: ajax_url,
                        data: {
                            action: 'olo_get_restaurant',
                            restaurant_id: order_data.vendorid,
                            referer: window.location.href
                        },
                        success: function (response) {
                            var restaurant_data = JSON.parse(response);

                            // console.log('restaurant_data', restaurant_data);
                            //   envConsoleLog(restaurant_data);
                            var handoff_mode_label;
                            restaurant_data.labels.forEach(function (label) {
                                if (label.key == "handoffmode_" + order_data.deliverymode) {
                                    handoff_mode_label = label.value;
                                }
                            });
                            var thanks_instructions;
                            restaurant_data.labels.forEach(function (label) {
                                if (label.key == "manual_fire_label") {
                                    manual_fire_label = label.value;
                                }

                                if (label.key == "handoffmode_" + order_data.deliverymode) {
                                    handoff_mode_label = label.value;
                                }

                                if (
                                    label.key ==
                                    "thanks_" + order_data.deliverymode + "_instructions"
                                ) {
                                    thanks_instructions = label.value;
                                } else if (
                                    label.key ==
                                    "thanks_" + order_data.deliverymode + "pickup_instructions"
                                ) {
                                    thanks_instructions = label.value;
                                } else if (
                                    label.key ==
                                    "thanks_" + order_data.deliverymode + "instructions"
                                ) {
                                    thanks_instructions = label.value;
                                }
                            });
                            $(".width-limiter span[data-thanks-instruction]").text(thanks_instructions);

                            //Google address link
                            let fullAddress = `${restaurant_data.streetaddress}, ${restaurant_data.city}, ${restaurant_data.state} ${restaurant_data.zip}`;
                            let encodedAddress = encodeURIComponent(fullAddress);
                            let googleAddressLink = `https://www.google.com/maps/dir/?api=1&destination=${encodedAddress}`;
                            $("[data-store-direction-link]").attr("href", googleAddressLink);
                            // console.log('googleAddressLink', googleAddressLink);

                            //
                            $('[data-store-location-address]').text(restaurant_data.streetaddress);
                            $('[data-store-location-state-zip]').text(restaurant_data.city + ', ' + restaurant_data.state + ' ' + restaurant_data.zip);

                            if ($('.homepage-order-status.order-tracker')) {
                                $('.homepage-order-status.order-tracker').removeClass('noShow');
                            }
                        }
                    });
                }

            }
        });


    }
});